import Vue from 'vue';

export default [
    {
        pathId: 'cps',
        component: 'content-providers',
        title: 'Content Providers',
        icon: 'fa-person-chalkboard',
        size: 'md', //sm, md, lg, xl
    },{
        pathId: 'cpun',
        component: 'new-content-provider',
        title: 'New Content Provider',
        icon: 'fa-plus',
        size: 'md',
    }, {
        pathId: 'cpue',
        component: 'edit-org-user',
        title: 'Edit User',
        icon: 'fa-pencil',
        size: 'md',
        props: ['userId'],
        loading: true
    }
];

Vue.component('content-providers', () => import('@/cards/content_providers/ContentProviders'));
Vue.component('new-content-provider', () => import('@/cards/content_providers/NewProvider'));
// Vue.component('edit-org-user', () => import('@/cards/organization/EditUser'));
